import { useState } from "react";
import axios from '../api/axiosInstance';

function getLocalDateTimeString() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

function AdminAddBloodPressureModal({ open, user, onClose, onSuccess }) {
  const [form, setForm] = useState({
    systolic: "",
    diastolic: "",
    heartRate: "",
    notes: "",
    recordedAt: getLocalDateTimeString(),
  });

  const token = localStorage.getItem("token");

  const handleSubmit = async () => {
    try {
      await axios.post(
        "/api/BloodPressure",
        {
          userId: user.userId,
          ...form,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert("新增成功");
      onClose();
      if (onSuccess) onSuccess();
    } catch {
      alert("新增失敗");
    }
  };

  if (!open || !user) return null;

  return (
    <>
      <div
        className="modal show fade d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1055 }} // Bootstrap 預設 modal 層級
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">新增血壓 - {user.name}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <label className="form-label">紀錄時間</label>
                <input
                  type="datetime-local"
                  className="form-control mb-2"
                  value={form.recordedAt}
                  onChange={(e) => setForm({ ...form, recordedAt: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">收縮壓</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  className="form-control mb-2"
                  value={form.systolic}
                  onChange={(e) => setForm({ ...form, systolic: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">舒張壓</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  className="form-control mb-2"
                  value={form.diastolic}
                  onChange={(e) => setForm({ ...form, diastolic: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">心跳</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  className="form-control mb-2"
                  value={form.heartRate}
                  onChange={(e) => setForm({ ...form, heartRate: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">備註</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={form.notes}
                  onChange={(e) => setForm({ ...form, notes: e.target.value })}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                取消
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                送出
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* 背景遮罩 */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
      ></div>
    </>
  );
}

export default AdminAddBloodPressureModal;
